import type { CmsProps } from '../../../types/cms'
import styled from '@emotion/styled'
import { Grid, Box } from '@mui/material'

export const CardsGrid = styled(Grid)<CmsProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 1rem;
  padding-right: 2rem;

  p {
    margin-top: 1rem;
    padding: 0;
    text-align: center;
  }
`

/** Fixed box so different CMS icon sizes don't shift titles/bodies. */
export const CardImage = styled(Box)<CmsProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 5.5rem;
  margin-bottom: 2rem;

  img {
    max-height: 100%;
    max-width: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
  }
`

export const CardTitle = styled.h5`
  margin: 0;
  padding: 0;
  text-align: center;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.5rem;
  letter-spacing: normal;
  text-transform: none;
`
